<template>
	<div class="loadingOverlay">
		<loading
			:show="show"
			:label="overlayLabel"
			overlay-class="dark-overlay"
			loader-class="centered-loader-wrapper"
			:event-bus="eventBus"
			event-show="show-loading-overlay"
			event-hide="hide-loading-overlay">
			<div slot="loading-spinner" class="centered-spinner">
				<span class="spinner-circle"></span>
			</div>
		</loading>
	</div>
</template>

<script>
import loading from 'vue-full-loading';

export default {
	name: 'loadingOverlay',
	introduction: 'Full page loading spinner',
	token: `<loadingOverlay></loadingOverlay>`,
	props: {
		show: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: ''
		},
		eventBus: {
			default: null
		},
	},
	computed: {
		overlayLabel() {
			return this.label;
		},
	},
	components: {
		loading
	}
};
</script>

<style lang="less" scoped>
.dark-overlay {
	background-color: rgba(0, 0, 0, 0.75);
	z-index: 9999;
	top: 0;
	left: 0;
	height: 100vh;
	width: 100vw;
	position: fixed;
	margin: 0;
	.centered-loader-wrapper {
		position: absolute;
		display: inline-block;
		left: calc(~"50vw - 40px");
		top: 50vh;
	}
	.centered-spinner {
		position: absolute;
		margin: auto;
		top: 0;
		right: 0;
		bottom: 40px;
		left: 16px;
		width: 40px;
		height: 40px;
	}
	.spinner-circle {
		width: 60px;
		height: 60px;
		border: 10px solid #999;
		border-top: 10px solid #0078ff;
	}
}
</style>
